import React, { Fragment, useEffect, useState } from "react";
import { UploadImage } from "../../../components/ui/profileSetup/bio/UploadImage";
import { createOrUpdateUserDetails } from "../../../config/apisauce";
import { VERIFY_FACE_ID_KEY } from "../../../enums/profileSetupEnums";
import { EditProfileButtons } from "./EditProfileButtons";
import useNotiStack from "../../../hooks/useNotiStack";

export const EditProfilePhotoForm = ({ creatorDetails, handleClose, refetchDetails, refetchCreatorList }) => {
  const { success } = useNotiStack();
  const [uploadedImages, setUploadedImages] = useState();
  const [profilePhoto, setProfilePhoto] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    const params = {
      profile_picture_id: profilePhoto?.id,
      user_id: creatorDetails?.user_id,
      current_step: VERIFY_FACE_ID_KEY
    };
    const { ok } = await createOrUpdateUserDetails(params);
    if (ok) {
      success('Successfully updated profile photo!');
      refetchDetails();
      refetchCreatorList();
      handleClose();
    }
    setLoading(false);
  };

  useEffect(() => {
    setProfilePhoto(creatorDetails?.profile_picture);
  }, [creatorDetails?.profile_picture]);

  return (
    <Fragment>
      <UploadImage
        hideSetProfile={true}
        uploadedImages={uploadedImages}
        profilePhoto={profilePhoto}
        currentPhotoId={creatorDetails?.profile_picture_id}
        setUploadedImages={setUploadedImages}
        userId={creatorDetails?.user_id}
        setProfilePhoto={setProfilePhoto}
      />
      <EditProfileButtons
        handCancel={() => handleClose()}
        handleSubmit={() => handleSubmit()}
        loading={loading}
      />
    </Fragment>
  );
};